interface ISpace extends React.ComponentProps<'div'> {
  space: string | number
}

export const SpacingVertical = ({ space, ...props }: ISpace) => {
  return <div tabIndex={-1} {...props} style={{ height: space }} />
}

export const SpacingHorizontal = ({ space, ...props }: ISpace) => {
  return <div tabIndex={-1} {...props} style={{ width: space }} />
}
